export interface VersionedProjection { id: string; updatedAt: number }

export function projectionsChanged(previous: VersionedProjection[], next: VersionedProjection[]): boolean {
  if (previous.length !== next.length) return true;
  const versions = new Map(previous.map(item => [item.id, item.updatedAt]));
  return next.some(item => versions.get(item.id) !== item.updatedAt);
}

export function shouldRebuildShell(contentChanged: boolean, editing: boolean): boolean {
  return contentChanged && !editing;
}
